import { Component, triggerPublicEvent } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';

const enum Selectors {
	Input = '.js-a-radio-button__input',
}

@Component('RadioButton')
export class RadioButton extends GondelJqueryComponent {
	public sync() {
		$(Selectors.Input, this.$ctx).one('focus', () => triggerPublicEvent('gFormInteractionEvent', this));
	}
}
